var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecommendationengines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.667,
    height: 21.817,
    viewBox: "0 0 28.667 21.817",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -3.823)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.863,19.873h.346l-.072,3.82,5.57-3.82h8.425a1.484,1.484,0,0,0,1.486-1.479V8.923a1.485,1.485,0,0,0-1.486-1.48H7.863a1.485,1.485,0,0,0-1.486,1.48v9.47A1.485,1.485,0,0,0,7.863,19.873Zm-.59-10.95a.588.588,0,0,1,.59-.584H22.132a.588.588,0,0,1,.59.584v9.47a.588.588,0,0,1-.59.583h-8.7L9.066,21.968l.056-2.992H7.863a.588.588,0,0,1-.59-.583V8.923Z",
    transform: "translate(-0.664 -4.2)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.356,
    height: 0.896,
    transform: "translate(9.207 6.476)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.003,
    height: 0.896,
    transform: "translate(9.207 9.309)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.909,25.64H26.758a1.911,1.911,0,0,0,1.909-1.909v-18a1.91,1.91,0,0,0-1.909-1.908H1.909A1.91,1.91,0,0,0,0,5.731v18A1.911,1.911,0,0,0,1.909,25.64ZM.9,5.731A1.014,1.014,0,0,1,1.909,4.719H26.758a1.014,1.014,0,0,1,1.013,1.012v18a1.014,1.014,0,0,1-1.013,1.013H1.909A1.015,1.015,0,0,1,.9,23.732Z",
    transform: "translate(0 -3.823)",
    fill: "#0080ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendationengines);
export default __webpack_public_path__ + "static/media/recommendationengines.e78e4f32.svg";
export { ForwardRef as ReactComponent };